import * as React from "react";
import { IconProps } from "./IconProps";

export const IconArrowLeft2 = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="arrow-left">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 8.00009C2 7.82328 2.07024 7.65371 2.19526 7.52869L6.19526 3.52868C6.45561 3.26833 6.87772 3.26833 7.13807 3.52868C7.39842 3.78902 7.39842 4.21113 7.13807 4.47149L4.27614 7.33343L13.3333 7.33343C13.7015 7.33343 14 7.6319 14 8.00009C14 8.36828 13.7015 8.66676 13.3333 8.66676H4.27615L7.13807 11.5287C7.39842 11.789 7.39842 12.2111 7.13807 12.4715C6.87772 12.7318 6.45561 12.7318 6.19526 12.4715L2.19526 8.4715C2.07024 8.34647 2 8.17691 2 8.00009Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
